import * as React from 'react'
import { Table, TableBody, TableRow, TableCell, TableHead } from '@material-ui/core'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { withRouter, RouteComponentProps } from 'react-router'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { fetchTransactionChange, fetchTransactionDette, fetchTransactionPlacement } from 'src/core/redux/action/dashboardAction'
import { formatCurrency } from 'src/shared/utils/helpers'
import { fetchEnterprise } from 'src/core/redux/action/enterpriseInfosAction'
import { ITransactionDette, ITransactionPlacement, ITransactionChange } from 'src/type/transaction'
import { formatDate } from 'src/core/i18n/date'
import { Fender } from 'src/shared/Fender/Fender'
import DashboardPanel from 'src/page/Consumer/Dashboard/DashboardPanel'
import DashboardLoading from 'src/page/Consumer/Dashboard/DashboardLoading'


interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>  {
}

interface IState {
  transactionDette: ITransactionDette[];
  transactionChange: ITransactionChange[];
  transactionPlacement: ITransactionPlacement[];
  isFetchingDette: boolean;
  isFetchingChange: boolean;
  isFetchingPlacement: boolean;
}

class Dashboard extends React.Component<IProps, IState> {
  state = {
    transactionDette: [] as ITransactionDette[],
    transactionChange: [] as ITransactionChange[],
    transactionPlacement: [] as ITransactionPlacement[],
    isFetchingDette: false,
    isFetchingChange: false,
    isFetchingPlacement: false,
  }

  componentDidMount(){
    const {ftransactionChange, ftransactionDette, ftransactionPlacement, promisesWithProgress, toastError} = this.props
    this.setState({isFetchingDette: true, isFetchingChange: true, isFetchingPlacement: true})
    promisesWithProgress(
      ftransactionChange().then(res => this.setState({transactionChange: res.data})).catch(err => toastError(err.msg)).finally(() => this.setState({isFetchingChange: false})),
      ftransactionDette().then(res => this.setState({transactionDette: res.data})).catch(err => toastError(err.msg)).finally(() => this.setState({isFetchingDette: false})),
      ftransactionPlacement().then(res => this.setState({transactionPlacement: res.data})).catch(err => toastError(err.msg)).finally(() => this.setState({isFetchingPlacement: false})),
    )
  }

  render() {
    const {t, enterprise} = this.props
    const { transactionPlacement, transactionChange, transactionDette, isFetchingChange, isFetchingDette, isFetchingPlacement} = this.state
    return (
        <DashboardPanel
            label={t.last_oprations}
            icon="account_balance"
            redirect="operations"
        >
            {(isFetchingChange && isFetchingDette && isFetchingPlacement) && <DashboardLoading />}
            {(!isFetchingChange && !isFetchingDette && !isFetchingPlacement) && 
            <>
                {!!enterprise && (transactionChange.length > 0 || transactionPlacement.length > 0 || transactionDette.length > 0) &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t.Transactions.typologie_operation}</TableCell>
                            <TableCell>{t.Transactions.date_operation}</TableCell>
                            <TableCell>{t.Transactions.nominal}</TableCell>
                            <TableCell>{t.Transactions.cours_or_taux}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {(transactionChange.length > 0 && !!enterprise.habilitations && enterprise.habilitations.includes('change')) && transactionChange.map(tr => (
                        <TableRow key={tr.id}>
                            <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>
                                {tr.transaction.typologie_operation}
                            </TableCell>
                            <TableCell >{formatDate(new Date(tr.transaction.date_operation))}</TableCell>
                            <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>
                                {formatCurrency(tr.transaction.nominal) + " " + tr.devise_1}
                            </TableCell>
                            <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>
                                {tr.prix_exercice_option_1 ? tr.prix_exercice_option_1 : tr.cours_terme ? tr.cours_terme : tr.cours_spot ? tr.cours_spot : "-"}
                            </TableCell>
                        </TableRow>
                    ))}

                    {(transactionDette.length > 0 && !!enterprise.habilitations &&  enterprise.habilitations.includes('dette')) && transactionDette.map(tr => (
                        <TableRow key={tr.id}>
                            <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>
                                {tr.transaction.typologie_operation}
                            </TableCell>
                            <TableCell >{formatDate(new Date(tr.transaction.date_operation))}</TableCell>
                            <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>
                                {formatCurrency(tr.transaction.nominal) + " " + tr.devise_1}
                            </TableCell>
                            <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>
                                {tr.taux_1 ? tr.taux_1 : "-"}
                            </TableCell>
                        </TableRow>
                    ))}

                    {(transactionPlacement.length > 0 && !!enterprise.habilitations &&  enterprise.habilitations.includes('placement')) && transactionPlacement.map(tr => (
                        <TableRow key={tr.id}>
                            <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>
                                {tr.transaction.typologie_operation}
                            </TableCell>
                            <TableCell >{formatDate(new Date(tr.transaction.date_operation))}</TableCell>
                            <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>
                                {formatCurrency(tr.transaction.nominal) + " " + tr.devise_1}
                            </TableCell>
                            <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>
                                {tr.taux_1 ? tr.taux_1 : "-"}
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
                }
            </>
            }
            {(!isFetchingChange && !isFetchingDette && !isFetchingPlacement && transactionChange.length === 0 && transactionDette.length === 0 && transactionPlacement.length === 0) && 
                <Fender text={t.Dashboard_no_transactions} />
            }
        </DashboardPanel>
    )
}
}

const state2props = (state: RootState) => ({
  mapName: state.utils.mapCategories,
  mapProductType: state.utils.mapProductType,
  news: state.paginate.news.entities,
  user: state.accountInfo.connectedUser,
  enterprise: state.accountInfo.enterpriseSelected,
});

const dispatch2props = (dispatch: any) => ({
  fetchEnterprise: (id: string) => dispatch(fetchEnterprise(id)),
  ftransactionChange: () => dispatch(fetchTransactionChange()),
  ftransactionDette: () => dispatch(fetchTransactionDette()),
  ftransactionPlacement: () => dispatch(fetchTransactionPlacement()),
});

export default compose(
  withI18n,
  withRouter,
  withGlobalProgress,
  withToast,
  connect(state2props, dispatch2props),
)(Dashboard)



// WEBPACK FOOTER //
// ./src/page/Consumer/Dashboard/tabs/DashboardTransactions.tsx